<template>
  <div class="yh_detail_bd">
    <p class="crumbs">
      <span>您的位置：
      	<router-link to="/Index">首页</router-link>
      	> 年度热点 </span>
    </p>
    <div class="hot_main_box">
      <h4 class="fond txt_center">2018年度学术热点</h4>
      <h4 class="hot_tit_h">热点关键词云图</h4>
      <div class="hot_img_box">
        <img class="hot_img" :src="hot_img" alt="">
      </div>
      <h4 class="hot_tit_h">Top15 关键词</h4>
      <div class="hot_box">
        <p class="hot_item left txt_center" v-for="x in hot_list">{{x}}</p>

      </div>
    </div>
  </div>
</template>

<script>
import { 
  fn_toStrings
} from "../../static/js/reading.js";
export default { 
  data () {
    return {
      hot_list: [],
      hot_img: require("../static/img/hot/hot.jpg")
    } 
  },
  methods: {
  },
  mounted() {
    // this.$api.axios_hot().then(res => {
    //     this.hot_list = res.data;
    // })
    this.hot_list = require("../../static/json/hot.json");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../assets/css/hot");
</style>



// WEBPACK FOOTER //
// src/components/hot.vue